module.exports = __webpack_public_path__ + "img/avatar.80b5322e.png";